var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('core-toolbar'),_c('core-drawer'),_c('v-content',{attrs:{"id":"view"}},[_c('div',{attrs:{"id":"home"}},[_c('about'),_c('boss'),_c('workers'),_c('requisite'),_c('banner')],1)]),_c('core-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }